import { HTMLProps } from 'react'

export function IconPWLogoStatic({ className, ...props }: HTMLProps<SVGSVGElement>) {
    return (
        <svg className={className} {...props}>
            <use href={`#icon-pw-logo`} />
        </svg>
    )
}